// @ts-nocheck
/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import isEqual from 'lodash/isEqual';
import { isValueEmpty, safeJsonParse } from '../../utils/Utils';
import { notifySessionLogin } from '../../utils/sessionBroadcast';

const initialState = {
  isAuthenticate: !!localStorage.getItem('access_token'),
  userData: safeJsonParse('user_data'),
  profileData: safeJsonParse('profile_data'),
  permissions: safeJsonParse('user_permissions') || {},
  themeMode: localStorage.getItem('THEME_MODE') || 'light', // Initialize with saved value or default to light
};

const userSlice = createSlice({
  initialState,
  name: 'user',
  reducers: {
    loginSuccess: (state, action) => {
      localStorage.setItem('access_token', action.payload.token);
      localStorage.setItem('refresh_token', action.payload.refresh);
      localStorage.setItem('user_data', JSON.stringify(action.payload.user));
      if (!isValueEmpty(action.payload.profile)) {
        localStorage.setItem(
          'profile_data',
          JSON.stringify(action.payload.profile)
        );
      }
      state.isAuthenticate = true;
      state.userData = action.payload.user;
      state.profileData = action.payload.profile;
      localStorage.setItem(
        'remember_me',
        JSON.stringify(action.payload.remember)
      );
      // Emit only after the complete login/user state is persisted. Other tabs
      // can now reload without observing a partially initialized common-auth flow.
      notifySessionLogin();
    },

    login(state, action) {
      state.push(action.payload);
    },
    logout(state) {
      state.pop();
    },
    setUserPermissions: (state, action) => {
      if (isEqual(state.permissions, action.payload.permissions)) {
        return;
      }

      localStorage.setItem(
        'user_permissions',
        JSON.stringify(action.payload.permissions)
      );
      state.permissions = action.payload.permissions;
    },
    setThemeMode: (state, action) => {
      localStorage.setItem('THEME_MODE', action.payload.themeMode);
      state.themeMode = action.payload.themeMode;
    },
  },
});
export const { login, logout, loginSuccess, setUserPermissions, setThemeMode } =
  userSlice.actions;
export default userSlice.reducer;
